// Alias
import DefaultHeader from '../../header';
export default DefaultHeader;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@salesforce/design-system-react/module/components/lookup/menu/default-footer/index.js
// module id = 62
// module chunks = 0